export default __webpack_public_path__ + "static/media/book_7.81c8b2ec.svg";